import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/img/icons/new-alert.svg';
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 }, null, -1);
const _hoisted_2 = { class: "cd-modal__title" };
const _hoisted_3 = { class: "cd-modal__text" };
const _hoisted_4 = { class: "dialog dialog-buttons" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerDistributionModal',
    props: {
        isVisible: { type: Boolean }
    },
    emits: ['hide', 'save'],
    setup(__props, { emit }) {
        const props = __props;
        const hide = () => {
            emit('hide', true);
        };
        const save = () => {
            emit('save', true);
        };
        return (_ctx, _cache) => {
            const _component_btn = _resolveComponent("btn");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: props.isVisible,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((props.isVisible) = $event)),
                "show-close": false,
                "close-on-press-escape": false,
                "close-on-click-modal": false,
                width: "450",
                center: "",
                class: "cd-modal"
            }, {
                default: _withCtx(() => [
                    _hoisted_1,
                    _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.$t('customer-distribution.edit.modal.title')), 1),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('customer-distribution.edit.modal.text')), 1),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_btn, {
                            class: "btn btn-outline-ctx-primary",
                            onClick: hide
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('customer-distribution.edit.modal.btn-hide')), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_btn, {
                            class: "btn",
                            onClick: save
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('customer-distribution.edit.modal.btn-save')), 1)
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
